import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-matloader',
  templateUrl: './matloader.component.html',
  styleUrls: ['./matloader.component.css']
})
export class MatloaderComponent implements OnInit {

  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;

  constructor() { }

  ngOnInit() {
  }

}
